"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var reports;
        (function (reports) {
            var viewReport;
            (function (viewReport) {
                function init() {
                    addEvents();
                    renderForSelected();
                }
                viewReport.init = init;
                function addEvents() {
                }
                function renderForSelected() {
                    const paramsForSelection = getInitialParams();
                    const $container = $('#report-parameters');
                    $container.empty();
                    if (!paramsForSelection || paramsForSelection.length === 0)
                        return;
                    paramsForSelection.forEach((p, idx) => {
                        const inputId = `rp_${idx}`;
                        const label = $('<label/>')
                            .attr('for', inputId)
                            .addClass('col-form-label')
                            .text(p.Name || '');
                        if (p.HintText && p.HintText.trim().length > 0) {
                            const normalizeNewlines = (s) => s.replace(/\r/g, '').replace(/\n/g, '<br>');
                            const htmlEncode = (s) => $('<div/>').text(s).html();
                            let hint = normalizeNewlines(p.HintText.trim());
                            let validHint = '';
                            if (hint.indexOf('help.appenate') >= 0) {
                                if (window.appn && window.appn.isDefaultRequest)
                                    validHint = hint;
                            }
                            else {
                                validHint = hint;
                            }
                            if (validHint) {
                                const $hintWrapper = $('<span/>')
                                    .attr('data-widget', 'popover')
                                    .attr('data-trigger', 'manual')
                                    .attr('data-html', 'true')
                                    .attr('data-placement', 'top')
                                    .attr('data-content', htmlEncode(validHint));
                                const $inner = $('<span/>');
                                $inner.text(p.Name || '');
                                const $icon = $('<i/>').addClass('fa fa-question-circle');
                                $hintWrapper.append($inner).append('&nbsp;&nbsp;').append($icon);
                                label.empty().append($hintWrapper);
                            }
                        }
                        const $row = $('<div/>').addClass('form-group row');
                        const $labelCol = $('<div/>').addClass('col-md-3').append(label);
                        const $inputCol = $('<div/>').addClass('col-md-6');
                        const kindName = toEnumName(p.Kind);
                        const $hiddenKind = $('<input/>')
                            .attr('type', 'hidden')
                            .attr('name', `ReportParameters[${idx}].Kind`)
                            .val(kindName);
                        $inputCol.append($hiddenKind);
                        if (isTextKind(p.Kind)) {
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '');
                            applyRequiredIfNeeded($input, p);
                            $inputCol.append($input);
                        }
                        else if (isIntegerKind(p.Kind)) {
                            const $input = $('<input/>')
                                .attr('type', 'number')
                                .attr('step', '1')
                                .attr('inputmode', 'numeric')
                                .addClass('form-control')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '');
                            applyRequiredIfNeeded($input, p);
                            $input.on('keydown', function (e) {
                                const code = e.key || '';
                                const disallow = ['e', 'E', '+', '.', '-', ','];
                                if (code === '-') {
                                    const v = this.value || '';
                                    const isSelectionCoversAll = this.selectionStart === 0 && this.selectionEnd === v.length;
                                    if (v.indexOf('-') >= 0 && !isSelectionCoversAll) {
                                        e.preventDefault();
                                    }
                                    if (this.selectionStart !== 0) {
                                        e.preventDefault();
                                    }
                                    return;
                                }
                                if (disallow.indexOf(code) >= 0) {
                                    e.preventDefault();
                                }
                            });
                            $input.on('input', function () {
                                let v = this.value || '';
                                if (!/^\-?\d*$/.test(v)) {
                                    const negative = v.startsWith('-');
                                    v = v.replace(/[^\d]/g, '');
                                    this.value = (negative ? '-' : '') + v;
                                }
                            });
                            $inputCol.append($input);
                        }
                        else if (isDecimalKind(p.Kind)) {
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .attr('inputmode', 'decimal')
                                .attr('pattern', '^-?\\d*(?:\\.\\d*)?$')
                                .addClass('form-control')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '');
                            applyRequiredIfNeeded($input, p);
                            const DECIMAL_RE = /^-?\d*(?:\.\d*)?$/;
                            const rememberState = (el) => {
                                var _a, _b;
                                const $el = $(el);
                                $el.data('prevVal', el.value || '');
                                try {
                                    $el.data('selStart', (_a = el.selectionStart) !== null && _a !== void 0 ? _a : (el.value || '').length);
                                    $el.data('selEnd', (_b = el.selectionEnd) !== null && _b !== void 0 ? _b : (el.value || '').length);
                                }
                                catch (err) { }
                            };
                            $input.each(function () { rememberState(this); });
                            $input.on('keydown', function (e) {
                                var _a, _b;
                                const key = e.key || '';
                                const el = this;
                                const v = el.value || '';
                                const selStart = (_a = el.selectionStart) !== null && _a !== void 0 ? _a : v.length;
                                const selEnd = (_b = el.selectionEnd) !== null && _b !== void 0 ? _b : v.length;
                                const allowedControl = [
                                    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Enter'
                                ].includes(key);
                                if (allowedControl)
                                    return;
                                if (key === 'e' || key === 'E' || key === '+' || key === ',') {
                                    e.preventDefault();
                                    return;
                                }
                                if (key === '-') {
                                    const selectionCoversAll = selStart === 0 && selEnd === v.length;
                                    const alreadyHasMinus = v.indexOf('-') >= 0;
                                    const atStart = selStart === 0;
                                    if ((alreadyHasMinus && !selectionCoversAll) || !atStart) {
                                        e.preventDefault();
                                    }
                                    return;
                                }
                                if (key === '.') {
                                    const selectionCoversAll = selStart === 0 && selEnd === v.length;
                                    const alreadyHasDot = v.indexOf('.') >= 0;
                                    if (alreadyHasDot && !selectionCoversAll) {
                                        e.preventDefault();
                                    }
                                    return;
                                }
                                if (!/^\d$/.test(key)) {
                                    e.preventDefault();
                                    return;
                                }
                            });
                            $input.on('input', function () {
                                var _a, _b, _c, _d, _e;
                                const el = this;
                                const v = el.value || '';
                                if (!DECIMAL_RE.test(v)) {
                                    const $el = $(el);
                                    const prevVal = (_a = $el.data('prevVal')) !== null && _a !== void 0 ? _a : '';
                                    const selStart = (_b = $el.data('selStart')) !== null && _b !== void 0 ? _b : prevVal.length;
                                    const selEnd = (_c = $el.data('selEnd')) !== null && _c !== void 0 ? _c : prevVal.length;
                                    el.value = prevVal;
                                    try {
                                        el.setSelectionRange(selStart, selEnd);
                                    }
                                    catch (err) { }
                                }
                                else {
                                    try {
                                        const start = (_d = el.selectionStart) !== null && _d !== void 0 ? _d : v.length;
                                        const end = (_e = el.selectionEnd) !== null && _e !== void 0 ? _e : start;
                                        $(el).data('prevVal', v).data('selStart', start).data('selEnd', end);
                                    }
                                    catch (err) {
                                        $(el).data('prevVal', v);
                                    }
                                }
                            });
                            $inputCol.append($input);
                        }
                        else if (isBooleanKind(p.Kind)) {
                            const labelHtml = (label && label.html) ? label.html() : (p.Name || '');
                            $labelCol.empty();
                            const $hiddenFalse = $('<input/>')
                                .attr('type', 'hidden')
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .val('false');
                            const $checkbox = $('<input/>')
                                .attr('type', 'checkbox')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .val('true');
                            const $wrapper = $('<div/>')
                                .addClass('icheck-primary')
                                .addClass('appn-checkbox');
                            const $inlineLabel = $('<label/>')
                                .attr('for', inputId)
                                .html(labelHtml || '');
                            $wrapper.append($checkbox).append($inlineLabel);
                            $inputCol.append($hiddenFalse).append($wrapper);
                        }
                        else if (isDateTimeKind(p.Kind)) {
                            const $group = $('<div/>').addClass('input-group date datetimepicker');
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '');
                            applyRequiredIfNeeded($input, p);
                            const $icon = $('<i/>').addClass('fa fa-calendar fa-xs');
                            const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                            const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);
                            $group.append($input).append($append);
                            $inputCol.append($group);
                            try {
                                (appn.ui && appn.ui.dateTimePicker) ? appn.ui.dateTimePicker($group) : null;
                            }
                            catch (e) { }
                        }
                        else {
                        }
                        $row.append($labelCol).append($inputCol);
                        $container.append($row);
                    });
                    try {
                        (appn.popover && appn.popover.init) ? appn.popover.init() : null;
                    }
                    catch (e) { }
                }
                function applyRequiredIfNeeded($el, p) {
                    if (!p || !p.IsOptional) {
                        $el.attr('required', 'required').attr('aria-required', 'true');
                    }
                }
                function getInitialParams() {
                    const $hidden = $('#report-params');
                    if ($hidden.length === 0)
                        return [];
                    const val = $hidden.val() || '';
                    if (!val || !val.trim())
                        return [];
                    try {
                        return JSON.parse(val);
                    }
                    catch (e) {
                        return [];
                    }
                }
                function isTextKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 0;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'text';
                }
                function isDateTimeKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 6;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'datetime' || kind.toLowerCase() === 'dateTime'.toLowerCase();
                }
                function isIntegerKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 1;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'integer' || kind.toLowerCase() === 'int';
                }
                function isDecimalKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 2;
                    if (!kind)
                        return false;
                    const k = kind.toLowerCase();
                    return k === 'decimal' || k === 'number' || k === 'float' || k === 'double';
                }
                function isBooleanKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 3;
                    if (!kind)
                        return false;
                    const k = kind.toLowerCase();
                    return k === 'boolean' || k === 'bool';
                }
                function toEnumName(kind) {
                    var _a;
                    if (typeof kind === 'string') {
                        const k = kind.trim();
                        const l = k.toLowerCase();
                        if (l === 'datetime')
                            return 'DateTime';
                        if (l === 'multiselect' || l === 'multi-select')
                            return 'MultiSelect';
                        if (l === 'number' || l === 'float' || l === 'double')
                            return 'Decimal';
                        if (l === 'bool')
                            return 'Boolean';
                        return k.charAt(0).toUpperCase() + k.slice(1);
                    }
                    const map = ['Text', 'Integer', 'Decimal', 'Boolean', 'Date', 'Time', 'DateTime', 'Enum', 'Select', 'MultiSelect', 'Guid'];
                    return (_a = map[kind]) !== null && _a !== void 0 ? _a : 'Text';
                }
                try {
                    appn.pubSub.subscribe(appn.pubSub.APPN_READY, () => init());
                }
                catch (e) { }
            })(viewReport = reports.viewReport || (reports.viewReport = {}));
        })(reports = views.reports || (views.reports = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
